import React from 'react'
import get from 'lodash-es/get'
import classNames from 'classnames'

import SearchFilters from '../../components/filters/searchFilters'
import LoadingSpinner from '../../../shared/components/icons/loadingSpinner'
import SearchResultHeaderContainer from './result/searchResultHeaderContainer'
import SearchResultBody from './result/searchResultBody'
import SearchNoResults from './result/searchNoResults'
import RelatedSearches from './result/relatedSearches'
import ElementsBanner from '../../../shared/components/elementsBanner'
import StudioRecommendationsBanner from '../../../shared/components/studioRecommendationsBanner'
import { getConfigBySite } from '../../../../config/sites'
import Pagination from '../../components/pagination/pagination'
import CrossPromoBanner from '../../../shared/components/crossPromoBanner'

import * as styles from './searchContentSection.module.css'

const SearchContentSection = ({
  searchResultsViewType,
  baseUrl,
  results,
  location,
  loading,
  currentSite,
  relatedSearches,
  studioRecommendations,
  push,
  locationParams,
  makeSearchLink
}) => {
  const shouldShowRecommendedSearches =
    !loading && relatedSearches && relatedSearches.recommendations.length > 0

  const totalHits = results.total_hits
  const matches = results.matches
  const aggregations = get(results, 'aggregations')
  const haveResults = !!(matches && matches.length)
  const shouldShowPagination = totalHits > 0
  const shouldShowResultBody = haveResults && !loading
  const shouldShowNoResult = !haveResults && !loading
  const shouldShowLoading = loading
  const pageSize = getConfigBySite(currentSite, 'common.search_page_size')
  const maxPagesCount = getConfigBySite(currentSite, 'common.max_pages_count')
  const currentCategory = locationParams.category
  const containerClassNames = classNames('grid-container', {
    '-layout-videohive':
      currentSite === 'videohive' && searchResultsViewType === 'grid'
  })

  return (
    <div className={containerClassNames}>
      <aside className="sidebar-s -size-fixed-tablet fds-u-hide-small-and-below">
        <SearchFilters
          aggregations={aggregations}
          locationParams={locationParams}
          currentSite={currentSite}
          makeSearchLink={makeSearchLink}
        />
        <CrossPromoBanner
          currentSite={currentSite}
          currentCategory={currentCategory}
        />
      </aside>
      <div className="content-l -size-scale-tablet content-right">
        <SearchResultHeaderContainer
          date={get(aggregations, 'date')}
          locationParams={locationParams}
          makeSearchLink={makeSearchLink}
          location={location}
          push={push}
        />
        {shouldShowResultBody && (
          <SearchResultBody
            location={location}
            matches={matches}
            isSqueezed={true}
          />
        )}
        {shouldShowNoResult && (
          <SearchNoResults locationParams={locationParams} />
        )}
        {shouldShowLoading && (
          <LoadingSpinner
            className={styles.loadingSpinner}
            data-test-selector="loading-spinner"
          />
        )}
        {shouldShowRecommendedSearches && (
          <RelatedSearches {...relatedSearches} />
        )}
        {shouldShowPagination && (
          <Pagination
            currentPage={Number(location.query.page) || 1}
            currentSite={currentSite}
            totalItemsCount={totalHits}
            pageSize={pageSize}
            locationParams={locationParams}
            makeSearchLink={makeSearchLink}
            baseUrl={baseUrl}
            maxPagesCount={maxPagesCount}
          />
        )}
        {haveResults && <ElementsBanner currentSite={currentSite} />}
        {haveResults && (
          <StudioRecommendationsBanner
            config={studioRecommendations}
            currentSite={currentSite}
            category={locationParams.category}
            term={locationParams.term}
          />
        )}
      </div>
    </div>
  )
}

export default SearchContentSection
